import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const RunJavaOnPhone: React.FC = () => (
  <SEOLandingPage
    title="Run Java on Your Phone — Java Compiler for Android | Cosmovex"
    metaDescription="Run Java programs directly on your Android phone. Java Compiler & IDE Editor lets you write and execute Java code without a PC or internet connection."
    ogTitle="Run Java on Your Phone — Java Compiler for Android"
    h1="Run Java on Your Phone"
    intro="Stop carrying a laptop just to test a Java snippet. Java Compiler & IDE Editor runs Java programs natively on Android — compile on-device, see output in seconds."
    paragraphs={[
      "The question 'can I run Java on my phone?' has a definitive answer: yes, and it works better than you'd expect. Java Compiler & IDE Editor embeds a lightweight Java runtime on Android, letting you write and execute Java programs without any external server or cloud dependency.",
      "This is genuinely useful in real-world scenarios. You're reviewing code on your phone and spot a bug — instead of mentally simulating the logic, you write a quick test and run it right there. Or you're studying data structures and want to see how a sorting algorithm actually behaves with different inputs.",
      "The app handles standard Java from simple Hello World programs to complex multi-class logic with collections, generics, and exception handling. It's not a restricted subset — it's actual Java, compiled and run on your device.",
      "Output appears in a console panel below the editor. Errors show with line numbers. The workflow is compact but complete: write, tap run, see output, fix, repeat. No build system configuration required.",
    ]}
    features={[
      "Compile and run Java on Android without a PC",
      "Embedded Java runtime — fully offline",
      "Console output with error line numbers",
      "Supports classes, interfaces, and generics",
      "Collections framework support",
      "Exception handling and stack traces",
      "Multi-file programs",
      "Code history to revisit past programs",
      "Lightweight — under 20MB install size",
      "No account or internet required",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.javavedit"
    icon="/images/javavedit.png"
    appName="Java Compiler & IDE Editor"
    accentColor="#A8720E"
    canonicalPath="/run-java-on-phone"
  />
);

export default RunJavaOnPhone;
